<template>
  <!-- 根布局容器：必须包裹所有内容 -->
  <a-layout style="min-height: 100vh;">
    <!-- 侧边栏：无需 fixed，由布局容器自动控制 -->
    <a-layout-sider width="200" class="sider">
      <a-menu v-model:selectedKeys="selectedKeys" v-model:openKeys="openKeys" mode="inline" class="menu">
        <a-menu-item key="1" class="menu-item">
          <a-tooltip :title="'概览'" placement="right" :overlayStyle="{ maxWidth: '200px' }">
            <div class="menu-item-content">
              <BarChartOutlined class="menu-icon" />
              <span class="menu-label">概览</span>
            </div>
          </a-tooltip>
        </a-menu-item>
        <a-menu-item key="2" class="menu-item">
          <a-tooltip :title="'社交平台舆情分析'" placement="right" :overlayStyle="{ maxWidth: '200px' }">
            <div class="menu-item-content">
              <BarChartOutlined class="menu-icon" />
              <span class="menu-label">社交平台舆情分析</span>
            </div>
          </a-tooltip>
        </a-menu-item>
        <a-menu-item key="3" class="menu-item">
          <a-tooltip :title="'开发者工具需求(规划中)'" placement="right" :overlayStyle="{ maxWidth: '200px' }">
            <div class="menu-item-content">
              <BarChartOutlined class="menu-icon" />
              <span class="menu-label">开发者工具需求(规划中)</span>
            </div>
          </a-tooltip>
        </a-menu-item>

        <a-sub-menu key="sub-ai">
          <template #title>
            <span class="menu-label">AI提效自媒体</span>
          </template>
          <a-menu-item key="4" class="menu-item">
            <a-tooltip :title="'工作台'" placement="right" :overlayStyle="{ maxWidth: '200px' }">
              <div class="menu-item-content">
                <DashboardOutlined class="menu-icon" />
                <span class="menu-label">工作台</span>
              </div>
            </a-tooltip>
          </a-menu-item>
          <a-menu-item key="6" class="menu-item">
            <a-tooltip :title="'素材中心'" placement="right" :overlayStyle="{ maxWidth: '200px' }">
              <div class="menu-item-content">
                <FolderOutlined class="menu-icon" />
                <span class="menu-label">素材中心</span>
              </div>
            </a-tooltip>
          </a-menu-item>
          <a-menu-item key="7" class="menu-item">
            <a-tooltip :title="'镜头剪辑'" placement="right" :overlayStyle="{ maxWidth: '200px' }">
              <div class="menu-item-content">
                <VideoCameraOutlined class="menu-icon" />
                <span class="menu-label">镜头剪辑</span>
              </div>
            </a-tooltip>
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-sider>

    <!-- 主内容容器：自动占据侧边栏右侧剩余空间 -->
    <a-layout class="main-layout">
      <!-- 页面内容：只在右侧区域渲染 -->
      <main class="content-scroll">
        <VodOverview v-if="selectedKeys[0] === '1'" />
        <SocialMediaOpinion v-if="selectedKeys[0] === '2'" />
        <ComingSoonPage v-if="selectedKeys[0] === '3'" />
        <AiWorkbench v-if="selectedKeys[0] === '4'" />
        <MaterialCenter v-if="selectedKeys[0] === '6'" />
        <ShotEditing v-if="selectedKeys[0] === '7'" />
      </main>
    </a-layout>
  </a-layout>
</template>

<script setup>
import { h, ref, provide } from 'vue';
import { BarChartOutlined, DashboardOutlined, FolderOutlined, VideoCameraOutlined } from '@ant-design/icons-vue';
import { Tooltip as ATooltip } from 'ant-design-vue';
import VodOverview from './VodOverview.vue';
import SocialMediaOpinion from './SocialMediaOpinion.vue';
import AiWorkbench from '../ai-self-media/AiWorkbench.vue';
import MaterialCenter from '../ai-self-media/MaterialCenter.vue';
import ShotEditing from '../ai-self-media/ShotEditing.vue';

const selectedKeys = ref(['1']);
const openKeys = ref(['sub-ai']);
const ComingSoonPage = {
  render: () => h('div', { class: 'coming-soon' }, '开发中，敬请期待~')
};

function navigateTo(key) {
  selectedKeys.value = [key];
  if (['4', '6', '7'].includes(key)) {
    openKeys.value = ['sub-ai'];
  }
}
provide('navigateTo', navigateTo);
</script>

<style scoped>
.sider {
  box-shadow: 2px 0 8px #f0f1f2;
}

.menu {
  height: 100%;
  border-right: 0;
}

.menu-item {
  white-space: normal !important;
  height: auto !important;
  padding: 12px 16px !important;
}

.menu-item-content {
  display: flex;
  text-align: left;
  align-items: flex-start;
  gap: 8px;
}

.menu-icon {
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 2px;
}

.menu-label {
  flex: 1;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.main-layout {
  background: #f9fafb;
}

.content-scroll {
  padding: 0 24px 24px;
  overflow-y: auto;
  flex: 1;
}
</style>
